module.exports = __webpack_public_path__ + "img/External_60x60.46565318.jpg";